var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/display-name */
import * as React from 'react';
var SvgCaretleft = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props, { ref: ref }),
    React.createElement("path", { d: "M4.5 11.972c0-.662.283-1.292.778-1.73l11.13-9.81a1.84 1.84 0 012.568.195 1.85 1.85 0 01-.134 2.578L9.11 11.784a.25.25 0 000 .376l9.732 8.578a1.849 1.849 0 01-.609 3.17 1.84 1.84 0 01-1.825-.397L5.282 13.704a2.312 2.312 0 01-.782-1.732z" }))); });
export default SvgCaretleft;
//# sourceMappingURL=CaretLeftIcon.js.map